/**
 * LayoutsIcon — Tiles of different sizes: a layout of views. Hugeicons dashboard-square-03 (MIT).
 */

import svg from './svg/layouts.svg?raw';
import { makeSvgIcon } from './svgIcon';

export const LayoutsIcon = makeSvgIcon('layouts', svg);
